module.exports = __webpack_public_path__ + "img/vipzhuanshi.f71f693.png";